// extracted by mini-css-extract-plugin
export default {"formCheck":"Auth_formCheck__qHU-W","error":"Auth_error__HEiLJ"};